import { useEffect, useState } from 'react';
import { Check, X, PencilLine } from 'lucide-react';
import { trpc } from '@/data-loaders';
import { IconComponent } from '@/components';
import { Textarea } from '@/components/ui';
import { Button } from '@curtin-dxp/curtin-ui';
import { UnitWorkloadDetails } from '#server/models';
import { useHandleError, useHandleSuccess } from '@/hooks';

interface NoteProps {
  unitWorkloadDetails: UnitWorkloadDetails;
}
export const Note = ({ unitWorkloadDetails }: NoteProps) => {
  const [isNoteEditable, setIsNoteEditable] = useState(false);
  const [note, setNote] = useState<string | undefined>('');
  const handleError = useHandleError();
  const sendToastUpdateNoteSuccess = useHandleSuccess({ title: 'Update note' });

  const { mutate: updateNoteMutation, isError: isUpdatingNoteError } = trpc.updateUnitWorkloadNote.useMutation({
    onSuccess: async () => {
      sendToastUpdateNoteSuccess();
    },
    onError: (error) => {
      handleError([error]);
    },
  });

  useEffect(() => {
    if (unitWorkloadDetails) {
      setNote(unitWorkloadDetails?.note || '');
    }
  }, [unitWorkloadDetails]);

  // useEffect(() => {
  //   handleError([isUpdatingNoteError]);
  // }, [isUpdatingNoteError]);
  return (
    <div
      className="flex w-full flex-shrink-0 flex-col items-start gap-3 bg-primary-website-background-colour px-5 py-5
        text-primary-black-90"
    >
      <div className="flex-start flex items-center gap-2">
        <h4 className="min-h-8 font-proxima text-b1 font-bold">Add or edit a unit note</h4>
        {isNoteEditable ? (
          <div className="flex flex-row gap-1">
            <Button
              size="icon"
              variant="filled-secondary"
              className="h-8 w-8"
              onClick={() => {
                setIsNoteEditable(false);
                if (unitWorkloadDetails) setNote(unitWorkloadDetails.note ?? '');
              }}
            >
              <IconComponent IconType={X} />
            </Button>{' '}
            <Button
              size="icon"
              variant="filled-secondary"
              className="h-8 w-8"
              onClick={() => {
                setIsNoteEditable(false);
                if (unitWorkloadDetails)
                  updateNoteMutation({ note: note ?? '', unitWorkloadId: unitWorkloadDetails.id });
              }}
            >
              <IconComponent IconType={Check} />
            </Button>
          </div>
        ) : (
          <Button
            size="icon"
            variant="filled-secondary"
            className="h-8 w-8"
            onClick={() => {
              setIsNoteEditable(true);
            }}
          >
            <IconComponent IconType={PencilLine} />
          </Button>
        )}
      </div>

      <Textarea
        className="h-[250px] w-full flex-shrink-0 rounded-lg border-secondary-grey-03 bg-primary-website-background-colour text-[12px]
          leading-6 text-black"
        maxLength={5000}
        disabled={!isNoteEditable}
        value={note}
        onChange={(e) => {
          setNote(e.target.value);
        }}
      ></Textarea>
      {isNoteEditable && <div className="self-end text-xs">{5000 - (note?.length ?? 0)} characters remaining.</div>}
    </div>
  );
};
